<template lang="pug">
.item.corpslist-entry(:class='{ active: expanded }')
  .image.stacked
    span(v-for='c in member.colors.slice().reverse()')
      i.avatar.corps(:style='c.colors_css' :title='c.colors_title')
    span(v-if="!member.has_avatar")
      i.avatar.corps(:style="`background: url('` + member.avatar + `');background-size: cover;transform: rotate(0deg);`")
  .content
    .header
      .title
        i.ui.icon.suus-search-3(v-if='!member.verified' v-tooltip="'Verifizierung ausstehend.'")
        span(v-if='member.resigned') &nbsp;&#128148;&#xFE0E;
        span.list_name(v-html="member.list_name")
        i.ui.icon.suus-connect(v-if='member.ally_only'
          v-tooltip="{content: $t('components.memberlist_item.ally_client'), delay: 200}")
        template(v-if='member.alive')
          span.age(v-if='member.birthdate' :title='member.birthdate')
            | &nbsp;({{member.age}})
          template(v-if='!member.resigned')
            i.ui.icon.suus-time-3(v-if='member.sign_in_count === 0 && member.email && member.invitation_accepted_at'
                                  v-tooltip="{content: $t('components.memberlist_item.activated_but_not_logged_in'), delay: 200}")
            i.ui.icon.suus-hourglass(v-if='member.sign_in_count === 0 && member.email'
                                     v-tooltip="{content: $t('components.memberlist_item.invitation_not_accepted'), delay: 200}")

            i.ui.icon.suus-alert-circle-exc(v-if='!member.email'
              v-tooltip="{content: $t('components.memberlist_item.no_email'), delay: 200}")
            i.ui.icon.suus-alert.red(v-else-if='isBounced'
              v-tooltip="{content: $t('components.memberlist_item.mail_not_working'), delay: 200}")
            i.ui.icon.suus-check-circle-08.green(v-else-if='isAutomaticallyVerified || isManuallyVerified'
              v-tooltip="{content: $t('components.memberlist_item.verified'), delay: 200}")
        template(v-else='')
          span.age
            | &nbsp;(&dagger;
            template(v-if='member.date_of_death')  {{member.date_of_death}}
            | )
    .meta.right.ui.grid.three.columns
      .column
        template(v-if='member.job')
          i.ui.icon.suus-briefcase-24
          .text.job {{ member.job }}
      .column
        template(v-if='member.region || member.postal_code')
          i.ui.icon.suus-square-pin
          .text
            span.zip {{ member.postal_code }}
            | &nbsp;
            span.city {{ member.region }}
    .actions(@click.stop='')
      a.ui.icon.button(:class='{ disabled: !member.phone_number && !member.main_landline }' target="_blank" :href="tel_url")
        i.ui.icon.suus-phone-call
        span.mobile.only Anrufen
      a.ui.icon.button.primary(:class='{ disabled: !member.email || isBounced, red: isBounced}' target="_blank" :href="member.email ? 'mailto:' + member.email : null" @click.stop)
        i.ui.icon.suus-at-sign
        span.mobile.only E-Mail schreiben
    transition(name='slide-fade')
      .extra.items(v-if='expanded')
        .item(v-if='member.chairs.length > 0')
          i.ui.icon.suus-business-contact-89
          | {{member.chairs.join(", ")}}
        .item(v-if='member.phone_number')
          i.ui.icon.suus-phone-2
          span.phone
            a.tel.boxed(:class='{ disabled: !member.phone_number && !member.main_landline }' target="_blank" :href="tel_url" @click.stop)
              | {{ member.phone_number }}
        .item(v-if='member.email')
          i.ui.icon.suus-at-sign
          span.email
            a(:class='{ disabled: !member.email }' target="_blank" :href="member.email ? 'mailto:' + member.email : null" @click.stop) {{ member.email }}
        .item
          i.ui.icon.suus-a-sync
          | Stand: {{ member.updated_at }}
        .item
          i.ui.icon.suus-badge-13
          a(:href="'/member/' + member.club_record_id + '.vcf'" @click.stop='') Kontakt herunterladen
    transition(name='slide-fade')
      .extra.right.floated(v-if='expanded' @click.stop='')
        a.ui.primary.button(:target="profileTarget" :href="'/member/' + member.club_record_id") Profil ansehen
        a.ui.button.mobile.hidden(v-if='member.editable' target="_blank" :href="'/users/' + member.user_id + '/edit'") Bearbeiten
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { EmailStatuses } from "suus-api"
import { isPWA } from "app/modules/core/pwa-functions"

export default defineComponent({
  name: "MemberlistItem",
  props: {
    member: { type: Object, required: true },
    expanded: { type: Boolean, default: false },
  },
  data: function () {
    return {}
  },
  computed: {
    tel_url(): string | null {
      if (this.member.phone_number) {
        return "tel:" + this.member.phone_number
      } else if (this.member.main_landline) {
        return "tel:" + this.member.main_landline
      } else {
        return null
      }
    },

    isBounced(): boolean {
      return this.member.email_status === EmailStatuses.Bounced
    },
    isAutomaticallyVerified(): boolean {
      return this.member.email_status === EmailStatuses.AutomaticallyVerified
    },
    isManuallyVerified(): boolean {
      return this.member.email_status === EmailStatuses.ManuallyVerified
    },
  },
  setup() {
    const profileTarget = isPWA() ? "_self" : "_blank"
    return {
      profileTarget,
    }
  },
})
</script>

<style scoped>
.primary.button.disabled.red {
  background: #ff7878 !important;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
